export const doctorProcedureCreateTranslations = {
    en: {
        fetchOpdFailed: "Failed to fetch OPD numbers!",
        fetchDiseasesFailed: "Failed to fetch diseases",
        submitSuccess: "Doctor Procedure added successfully!",
        submitFailed: "Failed to add procedure!",
        submitting: "Submitting...",
        submit: "Submit",

        patientInformation: "Patient Information",
        tokenNo: "Token No",
        tokenPlaceholder: "Search Token No eg. 00005",
        beneficiaryName: "Beneficiary Name",
        date: "Date",
        mobile: "Mobile",
        gender: "Gender",
        age: "Age",
        maritalStatus: "Marital Status",
        aadhar: "Aadhar",
        email: "Email",
        district: "District",
        taluka: "Taluka",

        diseaseInformation: "Disease Information",
        disease: "Disease",
        subDisease: "Sub Disease",
        otherDisease: "Other Disease",
        selectAdvice: "Select Advice here",
        findingsAndObservations: "Findings and Observations",

        referralInformation: "Referral Information",
        referTo: "Refer To"
    },
    mr: {
        fetchOpdFailed: "ओपीडी क्रमांक आणण्यात अयशस्वी!",
        fetchDiseasesFailed: "रोग आणण्यात अयशस्वी",
        submitSuccess: "डॉक्टर प्रक्रिया यशस्वीरित्या जोडली!",
        submitFailed: "प्रक्रिया जोडण्यात अयशस्वी!",
        submitting: "सबमिट करत आहे...",
        submit: "सबमिट करा",

        patientInformation: "रुग्ण माहिती",
        tokenNo: "टोकन क्रमांक",
        tokenPlaceholder: "टोकन क्रमांक शोधा उदा. 00005",
        beneficiaryName: "लाभार्थीचे नाव",
        date: "तारीख",
        mobile: "मोबाइल",
        gender: "लिंग",
        age: "वय",
        maritalStatus: "वैवाहिक स्थिती",
        aadhar: "आधार",
        email: "ईमेल",
        district: "जिल्हा",
        taluka: "तालुका",

        diseaseInformation: "रोग माहिती",
        disease: "रोग",
        subDisease: "उप रोग",
        otherDisease: "इतर रोग",
        selectAdvice: "येथे सल्ला निवडा",
        findingsAndObservations: "निष्कर्ष आणि निरीक्षणे",

        referralInformation: "संदर्भ माहिती",
        referTo: "यांना संदर्भित करा"
    }
};
